import { DateTime } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeCounterProps } from './types';

/**
 * Counter
 */
export const Counter: FunctionComponent<TypeCounterProps> = ({
  className = '',
  days,
  hours,
  minutes,
  seconds,
}: TypeCounterProps) => (
  <div
    className={`u-label u-label--s flex flex-row items-center gap-0.5 [&_div]:before:mr-0.5 [&_div]:before:content-["•"] first:[&_div]:before:content-[""] ${className}`}
  >
    {days && <DateTime time={days} type="D" />}
    {hours && <DateTime time={hours} type="H" />}
    {minutes && <DateTime time={minutes} type="M" />}
    {seconds && (
      <DateTime
        time={seconds}
        type="S"
        className={days ? 'hidden 2xl:block' : ''}
      />
    )}
  </div>
);

Counter.displayName = 'Counter';
